import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance145 = () => {
  let winners = ["49", "207", "66", "27", "62", "64", "158", "141"];
  return <IndividualTable matchType={"16"} gender="F" event="145" subTitle="Kungdo" data={sampleData2} topRankCount="8" winners={winners} />;
};
export default Distance145;
